<template>
	<div class="login-container">
		<div class="login-card">
			<div class="login-header">
				<h1 class="logo">柏宁AI智能体</h1>
				<p class="slogan">智能创作平台</p>
			</div>
			<el-form :model="loginForm" :rules="rules" ref="loginFormRef" class="login-form">
				<el-form-item prop="adminPhone">
					<el-input v-model="loginForm.adminPhone" placeholder="手机号" prefix-icon="el-icon-phone">
					</el-input>
				</el-form-item>
				<el-form-item prop="adminPwd">
					<el-input v-model="loginForm.adminPwd" type="password" placeholder="密码"
						prefix-icon="el-icon-lock" @keyup.enter="handleLogin">
					</el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" class="login-btn" @click="handleLogin" :loading="loading">
						登录
					</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	const BASE_URL = 'https://ai.boningnet.cn/api'

	export default {
		name: 'Login',
		data() {
			return {
				loginForm: {
					adminPhone: '',
					adminPwd: ''
				},
				rules: {
					adminPhone: [
						{ required: true, message: '请输入手机号', trigger: 'blur' },
						{ pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
					],
					adminPwd: [
						{ required: true, message: '请输入密码', trigger: 'blur' }
					]
				},
				loading: false,
				loginFormRef: null
			}
		},
		methods: {
			handleLogin() {
				this.$refs.loginFormRef.validate((valid) => {
					if (!valid) {
						return
					}
					this.loading = true
					axios.post(`${BASE_URL}/admin/login`, {
						adminPhone: this.loginForm.adminPhone,
						adminPwd: this.loginForm.adminPwd
					}).then(res => {
						if (res.data && res.data.adminName) {
							localStorage.setItem('adminInfo', JSON.stringify(res.data))
							this.$message.success('登录成功')
							this.$router.push('/assignment')
						} else {
							this.$message.error('登录失败，请检查手机号或密码')
						}
					}).catch(() => {
						this.$message.error('登录失败，请检查手机号或密码')
					}).finally(() => {
						this.loading = false
					})
				})
			}
		}
	}
</script>

<style scoped>
	.login-container {
		min-height: 100vh;
		display: flex;
		justify-content: center;
		align-items: center;
		background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	}

	.login-card {
		width: 400px;
		padding: 40px;
		background-color: #fff;
		border-radius: 16px;
		box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
	}

	.login-header {
		text-align: center;
		margin-bottom: 32px;
	}

	.logo {
		font-size: 28px;
		font-weight: 700;
		color: #1f2937;
		margin: 0 0 8px 0;
		letter-spacing: 2px;
	}

	.slogan {
		font-size: 14px;
		color: #6b7280;
		margin: 0;
	}

	.login-form {
		width: 100%;
	}

	.login-btn {
		width: 100%;
		height: 44px;
		font-size: 16px;
		border-radius: 8px;
	}
</style>